import { render, staticRenderFns } from "./OrderAccordion.vue?vue&type=template&id=6aa9c3f2&scoped=true"
import script from "./OrderAccordion.vue?vue&type=script&lang=js"
export * from "./OrderAccordion.vue?vue&type=script&lang=js"
import style0 from "./OrderAccordion.css?vue&type=style&index=0&id=6aa9c3f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9c3f2",
  null
  
)

export default component.exports